import React from 'react'
import {
  MobileAppBannerMobile,
  MobileAppBannerMobileText,
  MobileAppBannerDesktop,
  MobileAppBannerMobileImage,
  MobileBannerContent,
  MobileAppBannerDesktopText,
  MobileAppBannerDesktopQRCode,
  MobileAppBannerDesktopImage,
  ImageContainer,
} from './styles'
import { LinkButton } from 'components/@common/Button'

const APP_DOWNLOAD_LINK = 'https://tempcover.onelink.me/4oOc/yg043438'

export const MobileAppBanner = () => {
  return (
    <>
      <MobileAppBannerMobile>
        <MobileBannerContent>
          <div>
            <MobileAppBannerMobileText>
              Get <strong>discounts</strong> on future policies by downloading
              the Tempcover app.
            </MobileAppBannerMobileText>
            <LinkButton
              href={APP_DOWNLOAD_LINK}
              style={{ width: '100%', marginBottom: '10px' }}
              id='mobile-app-banner-mobile-cta'
            >
              Download
            </LinkButton>
          </div>
          <ImageContainer>
            <MobileAppBannerMobileImage />
          </ImageContainer>
        </MobileBannerContent>
      </MobileAppBannerMobile>

      <MobileAppBannerDesktop>
        <MobileAppBannerDesktopQRCode />
        <MobileAppBannerDesktopText>
          Get <strong>discounts</strong> on future policies in the Tempcover
          app. Scan the QR code to download.
        </MobileAppBannerDesktopText>
        <MobileAppBannerDesktopImage />
      </MobileAppBannerDesktop>
    </>
  )
}
